import Vue from "vue";
import VueRouter from "vue-router";
import authRouter from "./modules/auth";
// import Layout from "@/views/layout/TheLayout.vue";

Vue.use(VueRouter);

export const constantRoutes = [
  {
    path: "/",
    name: "Map",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/",
        alias: "/",
        component: () => import("@/components/Map/index"),
        name: "map",
        meta: {
          title: "Map",
          // roles: ['Admin',"install admin", "sales"],
          affix: true,
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-google-maps",
        },
      },
    ],
  },
  {
    path: "/overview",
    alias: "/overview",
    name: "Overview",
    component: () => import("@/components/Dashboard/index"),
    meta: {
      title: "Dashboard",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-home-variant-outline",
    },
  },
  {
    path: "/",
    name: "On Rent Equipment",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/on-rent",
        name: "on rent Equipment",
        component: () => import("@/components/Equipments/index"),
        meta: {
          // title: "On Rent",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/view-equipment-details",
        name: "View Equipment Details",
        component: () => import("@/components/viewEquipmentDetails/index"),
        meta: {
          title: "View Equipment Details",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/view-rental-equipment-details/:id?/:equipId?/:assetId",
        name: "View Rental Equipment Details",
        component: () =>
          import("@/components/ViewRentalEquipmentDetails/index"),
        meta: {
          title: "View Rental Equipment Details",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-account-check-outline",
        },
      },
    ],
  },
  {
    path: "/",
    name: "Birch Fleet",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/birch-fleet",
        name: "Birch Fleet",
        component: () => import("@/components/BirchEquipment/index"),
        meta: {
          // title: "On Rent",
          roles: ["Admin", "Birch User"],
        },
      },
      {
        path: "/view-birch-details/:id?/:equipId?/:assetId",
        name: "View Birch Details",
        // component: () => import("@/views/widget/ComingSoon.vue"),
        component: () => import("@/components/ViewBirchDetails/index"),
        meta: {
          title: "View Birch Details",
          roles: ["Admin", "Birch User"],
          icon: "mdi-crane",
        },
      },
    ],
  },
  {
    path: "/",
    name: "Customer Owned Equipment",
    component: { render: (c) => c("router-view") },
    // component: () => import("@/components/Equipments/index"),
    children: [
      {
        path: "/customer-owned-equipment",
        name: "customer owned equipment",
        // component: () => import("@/views/widget/ComingSoon.vue"),
        component: () => import("@/components/CustomerOwnedEquipment/index"),
        meta: {
          title: "Customer Owned Equipment",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-account-check-outline",
        },
      },
      {
        path: "/view-customer-owned-equipment-details/:id?/:equipId?/:assetId",
        name: "View Customer Owned Equipment Details",
        // component: () => import("@/views/widget/ComingSoon.vue"),
        component: () =>
          import("@/components/ViewCustomerOwnedEquipmentDetails/index"),
        meta: {
          title: "View Customer Owned Equipment Details",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-account-check-outline",
        },
      },
    ],
  },
  {
    path: "/",
    name: "Contracts",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/contracts",
        component: () => import("@/components/Contracts/index"),
        name: "contracts",
        meta: {
          title: "Contracts",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/view-contract-details/:id",
        component: () => import("@/components/viewContractDetails/index"),
        name: "View Contract Details",
        meta: {
          title: "Add User",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
    ],
  },
  {
    path: "/",
    name: "Service & Maintenance",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/service-template-management",
        component: () =>
          import("@/components/ServiceModule/ServiceTemplateList/index"),
        name: "Service Templates",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/service-template-management/:type",
        component: () =>
          import("@/components/ServiceModule/ServiceTemplateManagement/index"),
        name: "Create Service Templates",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/service-template-management/:type/:id",
        component: () =>
          import("@/components/ServiceModule/ServiceTemplateManagement/index"),
        name: "Update Service Templates",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/service-template-mapping",
        component: () =>
          import("@/components/ServiceModule/Servicemapping/index"),
        name: "Add New Service",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        // path: "/service-maintenance-details",
        path: "/service-template-mapping/new",
        component: () =>
          import("@/components/ServiceModule/ServiceMaintenance/index"),
        // name: "Service Maintenance & Details",
        name: "Map New Service Template",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/services",
        component: () =>
          import("@/components/ServiceModule/ServiceModuleReports/index"),
        name: "Services",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/completed-services",
        component: () =>
          import("@/components/ServiceModule/CompletedServiceRecords/index"),
        name: "Completed Services",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
    ],
  },
  {
    path: "/",
    name: "Reports",
    // meta: {
    //   title: "Reports",
    // },
    // redirect: "/reports/existing-active-alerts-report",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/view-all-reports",
        component: () => import("@/components/SMSReports/ViewAllReports/index"),
        // component: () => import("@/components/SMSReports/ViewAllReports/index"),
        name: "View All Reports",
        meta: {
          title: "View All Reports",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/utilization-report",
        component: () => import("@/components/UtilizationReport/index"),
        name: "Utilization Report - Detailed",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/existing-active-alerts-report",
        // component: () => import("@/views/widget/ComingSoon.vue"),
        component: () =>
          import("@/components/ExistingActiveAlertsReport/index"),
        name: "Existing Active Alerts",
        meta: {
          title: "Add User",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/on-rent-report",
        // component: () => import("@/views/widget/ComingSoon.vue"),
        component: () => import("@/components/OnRentReport/index"),
        name: "On Rent",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/scheduled-reports",
        component: () => import("@/components/ScheduledReports/index"),
        name: "Scheduled Reports",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      // {
      //   path: "/equipment-scheduled-for-pick-up-report",
      //   // component: () => import("@/views/widget/ComingSoon.vue"),
      //   component: () => import("@/components/EquipmentScheduledForPickupsReport/index"),
      //   name: "Scheduled for Pickup",
      //   meta: {
      //     roles: ["Admin", "Birch User",  "Customer"]
      //   }
      // },
      {
        path: "/new-operational-report",
        component: () => import("@/components/NewOperationalReport/index"),
        name: "New Operational",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/new-utilization-report",
        component: () => import("@/components/NewUtilizationReport/index"),
        name: "Utilization",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/on-reservation-report",
        component: () => import("@/components/ReservationReport/index"),
        name: "On Reservation",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/overdue-report",
        component: () => import("@/components/OverdueReport/index"),
        name: "Overdue",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/trip-report",
        component: () => import("@/components/TripReport/index"),
        name: "Trip",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/incident-report",
        component: () => import("@/components/IncidentReport/index"),
        name: "Incident",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/activity-report",
        component: () => import("@/components/ActivityReport/index"),
        name: "Activity",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/actual-spend-to-date",
        component: () =>
          import("@/components/SMSReports/ActualCostToDateReport/index"),
        name: "Actual Spend To Date",
        meta: {
          title: "Actual Spend To Date",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/off-rent",
        component: () => import("@/components/SMSReports/OffRentReport/index"),
        name: "Off Rent",
        meta: {
          title: "Off Rent",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      // {
      //   path: "/sms-on-rent",
      //   component: () => import("@/components/SMSReports/SMSOnRentReport/index"),
      //   name: "SMS On Rent",
      //   meta: {
      //     title: "SMS On Rent",
      //     roles: ["Admin", "Birch User",  "Customer"]
      //   }
      // },
      {
        path: "/on-rent-with-spend-analysis",
        component: () =>
          import("@/components/SMSReports/OnRentWithCostAnalysis/index"),
        name: "On Rent With Spend Analysis",
        meta: {
          title: "On Rent With Spend Analysis",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/planned-actual",
        component: () =>
          import("@/components/SMSReports/PlannedVsActualReport/index"),
        name: "Planned Vs Actual",
        meta: {
          title: "Planned Vs Actual",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/rent-to-date",
        component: () =>
          import("@/components/SMSReports/RentToDateAndProjectedReport/index"),
        name: "Rent To Date And Projected",
        meta: {
          title: "Rent To Date And Projected",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/items-rented",
        component: () =>
          import("@/components/SMSReports/ItemsRentedReport/index"),
        name: "Items Rented",
        meta: {
          title: "Items Rented",
          roles: ["Admin"],
        },
      },
      // {
      //   path: "/sms-reservation",
      //   component: () => import("@/components/SMSReports/SMSReservationReport/index"),
      //   name: "Reservation",
      //   meta: {
      //     title: "Reservation",
      //     roles: ["Admin", "Birch User",  "Customer"]
      //   }
      // },
      {
        path: "/active-maintenance",
        component: () =>
          import("@/components/SMSReports/ActiveMaintenanceReport/index"),
        name: "Active Maintenance",
        meta: {
          title: "Active Maintenance",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/historical-maintenance",
        component: () =>
          import("@/components/SMSReports/HistoricalMaintenanceReport/index"),
        name: "Historical Maintenance",
        meta: {
          title: "Historical Maintenance",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },

      {
        path: "/customer-balance",
        component: () =>
          import("@/components/SMSReports/CustomerBalanceReport/index"),
        name: "Customer Balance",
        meta: {
          title: "Customer Balance",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/service-call",
        component: () =>
          import("@/components/SMSReports/ServiceCallReport/index"),
        name: "Service Call",
        meta: {
          title: "Service Call",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
    ],
  },

  {
    path: "/",
    name: "Reserve & Plan",
    // meta: {
    //   title: "Reports",
    // },
    // redirect: "/reports/existing-active-alerts-report",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/create-planning-sheet",
        component: () =>
          import("@/components/ReserveAndPlan/CreatePlanningSheet/index"),
        name: "Create Planning Sheet",
        meta: {
          title: "Create Planning Sheet",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/create-planning-sheet/:sheetId",
        component: () =>
          import("@/components/ReserveAndPlan/CreatePlanningSheet/index"),
        name: "Create Planning Sheet",
        meta: {
          title: "Create Planning Sheet",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/view-current-sheets",
        component: () =>
          import("@/components/ReserveAndPlan/ViewCurrentSheets/index"),
        name: "View Current Sheets",
        meta: {
          title: "View Current Sheets",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/view-historical-sheets",
        component: () =>
          import("@/components/ReserveAndPlan/ViewHistoricalSheets/index"),
        name: "View Historical Sheets",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/purchase-quote-request/:itemKey",
        component: () =>
          import("@/components/ReserveAndPlan/PurchaseQuoteRequest/index"),
        name: "Purchase Quote Request",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
    ],
  },
  // {
  //   path: "/alerts",
  //   name: "Alerts",
  //   // component: () => import("@/components/Alerts/index"),
  //   component: () => import("@/views/widget/ComingSoon.vue"),
  //   meta: {
  //     title: "Alerts",
  //     roles: ["Admin", "Birch User",  "Customer"],
  //     icon: "mdi-alert-circle-check-outline",
  //   }
  // },
  {
    path: "/sms-alerts",
    name: "SMS Alerts",
    component: () => import("@/components/SMSAlerts/index"),
    // component: () => import("@/views/widget/ComingSoon.vue"),
    meta: {
      title: "SMS Alerts",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-message-alert",
    },
  },
  {
    path: "/access-control",
    name: "Access Control",
    component: { render: (c) => c("router-view") },
    redirect: "/access-control/codes",
    children: [
      {
        path: "codes",
        name: "Access Control Codes",
        component: () =>
          import("@/components/AccessControl/AccessControlCodesList/index"),
        meta: {
          title: "Access Control Codes",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-access-point",
        },
      },
      {
        path: "operators",
        name: "Access Control Operators",
        component: () =>
          import("@/components/AccessControl/AccessControlOperators/index"),
        meta: {
          title: "Operators",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-account-multiple-outline",
        },
      },
      {
        path: "operators/add",
        name: "Access Control Operators Management",
        component: () =>
          import(
            "@/components/AccessControl/AccessControlOperatorsManagement/index"
          ),
        meta: {
          title: "Add Operator",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "operators/edit/:id",
        name: "Edit Access Control Operators Management",
        component: () =>
          import(
            "@/components/AccessControl/AccessControlOperatorsManagement/index"
          ),
        meta: {
          title: "Edit Operator",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "operator-groups/add",
        name: "Group Control Operators Management",
        component: () =>
          import(
            "@/components/AccessControl/GroupControlOperatorsManagement/index"
          ),
        meta: {
          title: "Add Operator Group",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "operator-groups/edit/:id",
        name: "Edit Group Control Operators Management",
        component: () =>
          import(
            "@/components/AccessControl/GroupControlOperatorsManagement/index"
          ),
        meta: {
          title: "Edit Operator Group",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "jobsites",
        name: "Jobsite Access Codes",
        component: () =>
          import("@/components/AccessControl/JobsiteAccessCodes/index"),
        meta: {
          title: "Jobsite Access Codes",
          roles: ["Admin", "Customer"],
          icon: "mdi-map-marker-outline",
        },
      },
      {
        path: "setup",
        name: "Access Control Setup",
        component: () =>
          import("@/components/AccessControl/CustomerAccessSetup/index"),
        meta: {
          title: "Setup",
          roles: ["Admin", "Birch User"],
          icon: "mdi-key-outline",
        },
      },
    ],
  },
  // Pre-BE-1121 access-control paths. Kept as redirects so bookmarks, and the
  // links already sent to Birch, still land on the right screen. Function form
  // because a string redirect drops the query string, and the operator edit
  // screens read ?type=edit.
  {
    path: "/accessCodes/list",
    redirect: (to) => ({ path: "/access-control/codes", query: to.query }),
  },
  {
    path: "/access-codes",
    redirect: (to) => ({ path: "/access-control/setup", query: to.query }),
  },
  {
    path: "/access-control-operators",
    redirect: (to) => ({ path: "/access-control/operators", query: to.query }),
  },
  {
    path: "/jobsites-access-codes",
    redirect: (to) => ({ path: "/access-control/jobsites", query: to.query }),
  },
  {
    path: "/access-control-operators-management/add",
    redirect: (to) => ({
      path: "/access-control/operators/add",
      query: to.query,
    }),
  },
  {
    path: "/access-control-operators-management/edit/:id",
    redirect: (to) => ({
      path: `/access-control/operators/edit/${to.params.id}`,
      query: to.query,
    }),
  },
  {
    path: "/group-control-operators-management/add",
    redirect: (to) => ({
      path: "/access-control/operator-groups/add",
      query: to.query,
    }),
  },
  {
    path: "/group-control-operators-management/edit/:id",
    redirect: (to) => ({
      path: `/access-control/operator-groups/edit/${to.params.id}`,
      query: to.query,
    }),
  },
  {
    path: "/",
    name: "Customers",
    component: { render: (c) => c("router-view") },

    children: [
      {
        path: "/customers",
        name: "customers",
        // component: () => import("@/views/widget/ComingSoon.vue"),
        component: () => import("@/components/Customers/index"),
        meta: {
          title: "Customers",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-account-check-outline",
        },
      },
      {
        path: "/view-customer-details/:id",
        name: "View Customer Details",
        // component: () => import("@/views/widget/ComingSoon.vue"),
        component: () => import("@/components/ViewCustomerDetails/index"),
        meta: {
          title: "View Customer Details",
          roles: ["Admin", "Birch User", "Customer"],
          icon: "mdi-account-check-outline",
        },
      },
    ],
  },
  // {
  //   path: "/logout",
  //   name: "Access Control",
  //   click: () => {
  //     this.logout();
  //   }
  // },
  {
    path: "/",
    name: "Settings",
    // meta: {
    //   title: "User Management",
    // },
    // redirect: "/user-management/list",
    roles: ["Admin", "Birch User", "Customer"],
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/product-exclusions",
        component: () =>
          import("@/components/Settings/ProductExclusions/index"),
        name: "/product-exclusions",
        meta: {
          title: "Product Exclusions",
          roles: ["Admin", "Birch User"],
        },
      },
      {
        path: "/product-catalog",
        component: () => import("@/components/Settings/ProductCatalog/index"),
        name: "/product-catalog",
        meta: {
          title: "Product catalog",
          roles: ["Admin", "Birch User"],
        },
      },
    ],
  },
  {
    path: "/",
    name: "notifications",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/settings/notifications",
        component: () => import("@/components/Settings/Notifications/index"),
        name: "Notification Settings",
        meta: {
          roles: ["Admin", "Birch User"],
        },
      },
    ],
  },
  {
    path: "/",
    name: "Groups",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/groups-management/add",
        component: () => import("@/components/Settings/GroupsManagement/index"),
        name: "groups-management",
        meta: {
          title: "Add User",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/groups-management/list",
        component: () => import("@/components/Settings/Groups/index"),
        name: "groups",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/groups-management/edit/:id",
        component: () => import("@/components/Settings/GroupsManagement/index"),
        name: "editGroup",
        meta: {
          title: "Edit Group",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
    ],
  },

  {
    path: "/product-exclusion",
    component: { render: (c) => c("router-view") },
  },
  {
    path: "/",
    name: "User Management",
    // meta: {
    //   title: "User Management",
    // },
    // redirect: "/user-management/list",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/user-management/add",
        component: () => import("@/components/UserManagement/index"),
        name: "user-management",
        meta: {
          title: "Add User",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/user-management/list",
        component: () => import("@/components/UsersList/index"),
        name: "usersList",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/user-management/edit/:id",
        component: () => import("@/components/UserManagement/index"),
        name: "editUser",
        meta: {
          title: "Edit User",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
    ],
  },

  {
    path: "/",
    name: "Point Of Contacts",
    // meta: {
    //   title: "User Management",
    // },
    // redirect: "/point-of-contacts/list",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/point-of-contacts/add",
        component: () => import("@/components/Settings/PointOfContacts/index"),
        name: "point-of-contacts",
        meta: {
          title: "Add Point Of Contact",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/point-of-contacts/list",
        component: () =>
          import("@/components/Settings/PointOfContactsList/index"),
        name: "contactsList",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/point-of-contacts/edit/:id",
        component: () => import("@/components/Settings/PointOfContacts/index"),
        name: "editContact",
        meta: {
          title: "Edit Contact",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
    ],
  },
  {
    path: "/",
    name: "Alert Configuration",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/alert-configuration/add",
        component: () =>
          import("@/components/Settings/AddAlertConfiguration/index"),
        name: "addAlert",
        meta: {
          title: "Add Alert",
          roles: ["Admin", "Birch User"],
        },
      },
      {
        path: "/alert-configuration/list",
        component: () =>
          import("@/components/Settings/ListAlertConfiguration/index"),
        name: "listAlert",
        meta: {
          roles: ["Admin", "Birch User"],
        },
      },
      {
        path: "/alert-configuration/edit/:id",
        component: () =>
          import("@/components/Settings/AddAlertConfiguration/index"),
        name: "editAlert",
        meta: {
          title: "Edit Alert",
          roles: ["Admin", "Birch User"],
        },
      },
      {
        path: "/alert-configuration/read/:id",
        component: () =>
          import("@/components/Settings/ReadAlertConfiguration/index"),
        name: "readAlert",
        meta: {
          title: "Read Alert",
          roles: ["Admin", "Birch User"],
        },
      },
    ],
  },

  {
    path: "/",
    name: "Planning Sheet Mapping",
    component: { render: (c) => c("router-view") },

    children: [
      {
        path: "/planning-sheet-mapping",
        name: "Planning Sheet Mapping",
        // component: () => import("@/views/widget/ComingSoon.vue"),
        component: () => import("@/components/PlanningSheetExceptions/index"),
        meta: {
          title: "Planning Sheet Mapping",
          roles: ["Admin"],
          icon: "mdi-crop",
        },
      },
    ],
  },
  {
    path: "/",
    name: "Planning Sheet Mapping",
    component: { render: (c) => c("router-view") },

    children: [
      {
        path: "/planning-sheet-mapping",
        name: "Planning Sheet Mapping",
        // component: () => import("@/views/widget/ComingSoon.vue"),
        component: () => import("@/components/PlanningSheetExceptions/index"),
        meta: {
          title: "Planning Sheet Mapping",
          roles: ["Admin"],
          icon: "mdi-crop",
        },
      },
    ],
  },
  {
    path: "/",
    name: "Geofences",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/geofences/add",
        component: () => import("@/components/Geofences/AddGeoFence/index"),
        name: "Add Geofences",
        meta: {
          title: "Add Geofences",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/geofences/list",
        component: () => import("@/components/Geofences/GeoFencesList/index"),
        name: "geofences",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/geofences/edit/:id",
        component: () => import("@/components/Geofences/UpdateGeoFence/index"),
        name: "Update Geofences",
        meta: {
          title: "Edit Geofences",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
    ],
  },
  {
    path: "/",
    name: "Alerts",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/alerts/add/:type",
        component: () => import("@/components/Alarms/AddAlarms/index"),
        name: "Add Alerts",
        meta: {
          title: "Add Alerts",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/alerts/list",
        component: () => import("@/components/Alarms/AlarmsList/index"),
        name: "Alerts",
        meta: {
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
      {
        path: "/alerts/edit/:id/:type",
        component: () => import("@/components/Alarms/UpdateAlarm/index"),
        name: "Update Alerts",
        meta: {
          title: "Edit Alerts",
          roles: ["Admin", "Birch User", "Customer"],
        },
      },
    ],
  },
  {
    path: "/",
    name: "Alert Management",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/alert-management/list",
        component: () =>
          import("@/components/AlertManagement/AlertManagementList/index"),
        name: "Alerts",
        meta: {
          roles: ["Admin", "Birch User"],
        },
      },
      {
        path: "/alert-management/view/:id",
        component: () =>
          import("@/components/AlertManagement/ViewAlertManagement/index"),
        name: "View Alerts",
        meta: {
          title: "View Alerts",
          roles: ["Admin", "Birch User"],
        },
      },
    ],
  },
  {
    path: "/",
    // alias: "/profile",
    name: "Profile",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/user-profile",
        component: () => import("@/components/Profile/index"),
        name: "profile",
        meta: {
          title: "Profile",
          icon: "mdi-view-dashboard-outline",
          affix: true,
        },
      },
    ],
  },
  {
    path: "/",
    alias: "/change-password",
    name: "Change Password",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/change-password",
        component: () => import("@/components/ChangePassword/index"),
        name: "changePassword",
        meta: {
          title: "Change Password",
          icon: "mdi-view-dashboard-outline",
          affix: true,
        },
      },
    ],
  },
  {
    path: "/",
    alias: "/first-time-change-password",
    name: "First Time Change Password",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/first-time-change-password",
        component: () => import("@/components/FirstTimeChangePassword/index"),
        name: "First Time Change Password",
        meta: {
          title: "First Time Change Password",
          icon: "mdi-view-dashboard-outline",
          affix: true,
        },
      },
    ],
  },
  {
    path: "/",
    alias: "/two-factor-authenticate",
    name: "Two Factor Authentication",
    component: { render: (c) => c("router-view") },
    children: [
      {
        path: "/two-factor-authenticate",
        component: () => import("@/components/TwoFactorLogin/index"),
        name: "Two Factor Authentication",
        meta: {
          title: "Two Factor Authentication",
          icon: "mdi-view-dashboard-outline",
          affix: true,
        },
      },
    ],
  },
  {
    path: "/view-component",
    name: "View Component",
    component: () => import("@/components/ViewComponent/index"),
    meta: {
      title: "View Component",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-google-maps",
    },
  },
  {
    path: "/movement",
    name: "Movement",
    component: () => import("@/components/Movement/index"),
    meta: {
      title: "Movement",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-google-maps",
    },
  },
  // {
  //   path: "/all-reports",
  //   name: "All Reports",
  //   component: { render: c => c("router-view") },
  //   children: [
  //     {
  //       path: "/",
  //       // alias: "/",
  //       component: () => import("@/components/AllReports/index"),
  //       name: "All Reports",
  //       meta: {
  //         title: "Home",
  //         // roles: ['Admin',"install admin", "sales"],
  //         icon: "mdi-home-variant-outline",
  //         affix: true
  //       }
  //     }
  //   ]
  // },
  {
    path: "/all-reports",
    name: "All Reports",
    component: () => import("@/components/AllReports/index"),
    meta: {
      title: "All Reports",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-home-variant-outline",
    },
  },
  {
    path: "/events",
    name: "Events",
    component: () => import("@/components/Events/index"),
    meta: {
      title: "Events",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-google-maps",
    },
  },
  {
    path: "/insights",
    name: "Insights",
    component: () => import("@/components/Insights/index"),
    meta: {
      title: "Insights",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-google-maps",
    },
  },
  {
    path: "/telematics",
    name: "Telematics",
    component: () => import("@/components/Telematics/index"),
    meta: {
      title: "Telematics",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-google-maps",
    },
  },
  {
    path: "/specification",
    name: "Specification",
    component: () => import("@/components/Specification/index"),
    meta: {
      title: "Specification",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-google-maps",
    },
  },
  {
    path: "/trips",
    name: "Trips",
    component: () => import("@/components/Trips/index"),
    meta: {
      title: "Trips",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-map-marker-distance",
    },
  },
  {
    path: "/activeAlerts",
    name: "Active Alerts",
    component: () => import("@/components/ActiveAlerts/index"),
    meta: {
      title: "Active Alerts",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-bell-alert",
    },
  },
  {
    path: "/contract-details",
    name: "Contract Details",
    component: () => import("@/components/ContractDetails/index"),
    meta: {
      title: "Contract Details",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-google-maps",
    },
  },
  {
    path: "/contacts",
    name: "Contacts",
    component: () => import("@/components/Contacts/index"),
    meta: {
      title: "Contacts",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-google-maps",
    },
  },
  {
    path: "/items",
    name: "Items",
    component: () => import("@/components/Items/index"),
    meta: {
      title: "Items",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-google-maps",
    },
  },
  {
    path: "/labels",
    name: "Labels",
    component: () => import("@/components/Labels/index"),
    meta: {
      title: "Labels",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-google-maps",
    },
  },
  {
    path: "/notes",
    name: "Notes",
    component: () => import("@/components/Notes/index"),
    meta: {
      title: "Notes",
      roles: ["Admin", "Birch User", "Customer"],
      icon: "mdi-google-maps",
    },
  },
  {
    path: "*",
    name: "not-found",
    component: () => import("@/views/widget/AppError.vue"),
  },

  ...authRouter,
];

export default new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: constantRoutes,
});

export const asyncRoutes = [
  { path: "*", redirect: "/error/404", hidden: true },
];
